<kendo-tilelayout [columns]="3" [resizable]="false" [reorderable]="false" [navigable]="false" [gap]="{ rows: 0, columns: 0 }">
  <kendo-tilelayout-item [col]="1" [row]="1" [rowSpan]="1" class="kpi-1"
    *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)">
    <kendo-tilelayout-item-body
      *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)">
      <div class="upcoming-kpis">Upcoming KPI</div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
  <kendo-tilelayout-item [col]="2" [row]="1" [rowSpan]="1" class="kpi-2"
    *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)"><kendo-tilelayout-item-body>
      <div class="upcoming-kpis">Upcoming KPI</div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
  <kendo-tilelayout-item [col]="3" [row]="1" [rowSpan]="1" class="kpi-3"
    *ngIf="!(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog)">
    <kendo-tilelayout-item-body>
      <div class="upcoming-kpis">Upcoming KPI</div>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
  <kendo-tilelayout-item [col]="1" [row]="(gridApiRoute === gridRoutes.eiTransition || gridApiRoute === gridRoutes.eventLog) ? 1 : 2" [colSpan]="3" [rowSpan]="6" style="min-width: 0; max-width: 100%;">
    <kendo-tilelayout-item-header [title]="title" class="dashboard-header" *ngIf="title">
      <h2 class="dashboard-title">
        {{ title }}
      </h2>
    </kendo-tilelayout-item-header>
    <kendo-tilelayout-item-body style="overflow: auto;">
      <app-grid [columnDefinitions]="columnDefinitions" [expandedRowColumnDefinitions]="expandedRowColumnDefinitions"
        [gridApiRoute]="gridApiRoute" [studentSk]="studentSk" [initialState]="initialGridState" [gridHeader]="gridHeader"
        [addButtonText]="addButtonText" [gridNestedApiRoute]="gridNestedApiRoute"
        [initialNesteState]="initialNesteState" [permissionToView]="permissionToView" [refershGrid]="refershGrid"
        [referenceData]="referenceData" (addToGrid)="addToGrid.emit($event)" [studentDetails]="studentDetails">
      </app-grid>
    </kendo-tilelayout-item-body>
  </kendo-tilelayout-item>
</kendo-tilelayout>